<template>
  <div>
    <tsl-card :cardList="cardList">
      <template v-slot:version>
        <div class="version-upgrade">
          <div class="left">
            <comfort-gauge :count="systemRating" v-if="systemRating > 0" />
          </div>
          <div class="right">
            <!-- <div class="version" @click="() => toJump('/dashboard/devops/version/overview')">
              <div class="img">
                <img src="@/assets/img/desktop.png" alt="" />
              </div>
              <div class="rcon">
                <div class="name">TacOS</div>
                <div class="info">
                  <div>当前版本：TacOS Enterprise 22Q1</div>
                  <div>更新时间：2022/03/19 14:00:33</div>
                </div>
              </div>
            </div> -->
            <div class="card">
              <div
                class="item"
                v-for="(item, index) in menuList"
                :key="index"
                @click="toJump(item.path)"
              >
                <div class="item-left"><img :src="item.src" alt="" /></div>
                <div class="item-aright">
                  <div class="name">{{ item.name }}</div>
                  <div>
                    <p class="value">{{ item.value }}</p>
                    <p class="time">{{ item.time }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </tsl-card>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
import Chart from "@/components/dashboard/operation-index/comfort-gauge.vue";
import useApi from "@/utils/hooks/use-api";
import { getSystemHealth } from "@/api/dashboard/devops/index.js";
import { useStore } from "vuex";
import { ref, computed, watch, onMounted } from "vue";
export default {
  name: "version-upgrade",
  components: {
    [Card.name]: Card,
    [Chart.name]: Chart
  },
  setup() {
    const cardList = ref([
      {
        name: "version",
        title: "系统健康与升级"
      }
    ]);
    const menuList = ref([
      {
        name: "系统升级",
        value: "",
        time: "（近30天）",
        path: "/dashboard/devops/version/system-update",
        src: require("@/assets/svg/devops/system-up.svg")
      },
      {
        name: "服务升级",
        value: "",
        time: "（近30天）",
        path: "/dashboard/devops/version/service-update",
        src: require("@/assets/svg/devops/serve-up.svg")
      },
      {
        name: "应用升级",
        value: "",
        time: "（近30天）",
        path: "/dashboard/devops/version/application-update",
        src: require("@/assets/svg/devops/apply-up.svg")
      }
    ]);
    const toJump = (path) => {
      if (path) {
        window.open(path, "_blank");
      }
    };
    const data = ref({});
    const { result, fetchResource } = useApi(getSystemHealth);
    const store = useStore();
    //获取实例code
    const instanceCode = computed(() => {
      return store.state.dashboard.instanceCode;
    });
    const systemRating = ref(0);
    watch(instanceCode, () => {
      init(instanceCode.value);
    });
    const init = async (code) => {
      await fetchResource(code);
      data.value = result.value.data;
      menuList.value[0].value = data.value.systemUpdateNum;
      menuList.value[1].value = data.value.serviceUpdateNum;
      menuList.value[2].value = data.value.appUpdateNum;
      systemRating.value = Number(data.value.systemRating);
    };
    onMounted(() => {
      if (instanceCode.value) {
        init(instanceCode.value);
      }
    });
    return {
      cardList,
      menuList,
      toJump,
      init,
      data,
      systemRating
    };
  }
};
</script>
<style scoped lang="less">
.version-upgrade {
  display: flex;
  .left {
    width: calc(25% - 5px);
  }
  .right {
    width: 75%;
    margin-left: 48px;
    .version {
      display: flex;
      align-items: center;
      margin-left: -16px;
      cursor: pointer;
      .img {
        img {
          width: 128px;
          height: 80px;
        }
      }
      .rcon {
        margin-left: 16px;
        .name {
          color: #1d2129;
          font-weight: 500;
          font-size: 24px;
          line-height: 32px;
        }
        .info {
          margin-top: 8px;
          color: #86909c;
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
    .card {
      display: flex;
      margin-top: 16px;
      padding-top: 20px;
      .item {
        position: relative;
        top: 0;
        display: flex;
        width: 50%;
        height: 96px;
        margin-left: -16px;
        padding: 20px 7px;
        text-align: left;
        background-color: #f7f8fa;
        transition: all 0.3s ease-in-out;

        .name {
          margin-top: 2px;
          margin-bottom: 8px;
          color: #4e5969;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
        }
        .item-left {
          margin-right: 16px;
        }
        // & > :last-child {
        // display: flex;
        .value {
          display: inline-block;
          margin-right: 4px;
          color: #1d2129;
          font-size: 24px;
          font-family: DINBold;
          line-height: 24px;
          vertical-align: middle;
        }
        .time {
          display: inline-block;
          color: #86909c;
          font-weight: 400;
          font-size: 12px;
          line-height: 24px;
        }
        // }
      }
      .item:hover {
        top: -4px;
        background-color: #e5e6eb;
        cursor: pointer;
      }
      .item:nth-child(n + 2) {
        margin-left: 16px;
      }
    }
  }
}
</style>
